export default __webpack_public_path__ + "static/media/LogoCurbo.36834022.svg";